



































import UpdateAudioFileCategoryRequest from "@/api/dataSource/api/Spirit/Admin/Interfaces/Models/MusicService/UpdateAudioFileCategoryRequest";
import UpdateSleepStoryCategoryRequest from "@/api/dataSource/api/Spirit/Admin/Interfaces/Models/SleepStoryService/UpdateSleepStoryCategoryRequest";
import TranslationModel from "@/api/dataSource/api/Spirit/Admin/Interfaces/Models/TranslationModel";
import Vue from "vue"
import { Component, Prop, Watch } from "vue-property-decorator"

@Component
export default class CreateMusicCategoryPage extends Vue {
    get title(): string {
        return this.id ? 'Редактирование категории сонной истории': 'Добавление категории сонной истории';
    }
    get id(): number {
        if (!this.$route.params.id) {
            return 0;
        }
        return Number(this.$route.params.id);
    }
    isLoading = false;
    request = new UpdateSleepStoryCategoryRequest({
        Id: 0,
        Translations: []
    });
    async fetchData() {
        this.isLoading = true;
        const res = await this.$api.SleepStoryService.getCategoryAsync(this.id);
        this.request.Id = res.Id;
        this.request.Translations.forEach(tr => {
           const resT = (res.Translations || []).find(x=>x.LangCode == tr.LangCode);
           if (resT) {
               tr.Name = resT.Name;
           }
        });
        this.isLoading = false;
    }
    async created() {
        const langs = await this.$cacheProvider.getLanguagesAsync();
        this.request.Translations = (langs || []).map((x: string) => 
            new TranslationModel({
                LangCode: x,
                Name: ''
            }));
        if (this.$route.params.id) {
            await this.fetchData();
        }
    }
    async add() {
        var valid = (this.$refs.validator as any).isValid();
        if (!valid) {
            return;
        }
        this.isLoading = true;
        await this.$api.SleepStoryService.updateCategoryAsync(this.request);
        this.$dialog.success('Категория успешно добавлена');
        this.$router.back();
        this.isLoading = false;
    }
}
